export interface ContainerStyle {
  width: string;
  height: string;
}

export const BREAKPOINTS = {
  showMap: 799,
} as const;

export const CONTAINER_STYLE_DEFAULT: ContainerStyle = {
  width: '100%',
  height: '100%',
};

export const CONTAINER_STYLE_MOBILE: ContainerStyle = {
  width: '100%',
  height: '100vh',
};

export const getContainerStyle = (isMobile: boolean): ContainerStyle => {
  return isMobile ? CONTAINER_STYLE_MOBILE : CONTAINER_STYLE_DEFAULT;
};
